(() => {
  const threshold = 299900;
  const format = cents => `₹${new Intl.NumberFormat('en-IN').format(cents / 100)}`;
  let lastGiftUnlocked;
  const celebrateGiftUnlock = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const drawer = document.querySelector('cart-drawer.active');
    if (!drawer) return;
    const button = drawer.querySelector('#CartDrawer .gokwik-checkout .cart-drawer__checkout-btn, #CartDrawer .cart__ctas--figma-checkout .gokwik-checkout .button');
    const offer = drawer.querySelector('#CartDrawer .dt-diwali-cart-offer');
    if (!button || !offer) return;
    drawer.querySelector('.dt-gift-spark-trail')?.remove();
    const start = button.getBoundingClientRect();
    const end = offer.getBoundingClientRect();
    const trail = document.createElement('div');
    trail.className = 'dt-gift-spark-trail';
    trail.setAttribute('aria-hidden', 'true');
    for (let index = 0; index < 18; index++) {
      const spark = document.createElement('i');
      const fraction = (index + .5) / 18;
      spark.style.setProperty('--spark-x', `${start.left + start.width * fraction}px`);
      spark.style.setProperty('--spark-y', `${start.top + start.height * .25}px`);
      spark.style.setProperty('--spark-rise', `${Math.min(-80, end.top - start.top - 30)}px`);
      spark.style.setProperty('--spark-drift', `${Math.sin(index * 2.4) * 42}px`);
      spark.style.setProperty('--spark-size', `${4 + index % 3 * 2}px`);
      spark.style.setProperty('--spark-delay', `${index % 6 * 70}ms`);
      trail.appendChild(spark);
    }
    drawer.appendChild(trail);
    window.setTimeout(() => trail.remove(), 2400);
  };
  const refresh = () => fetch('/cart.js', { credentials: 'same-origin' }).then(response => response.ok ? response.json() : null).then(update).catch(error => console.warn('[Diwali offer] Cart amount unavailable', error));
  const update = cart => {
    if (!cart || typeof cart.total_price !== 'number') return;
    const remaining = Math.max(0, threshold - cart.total_price);
    const giftUnlocked = remaining === 0;
    document.querySelectorAll('.dt-diwali-cart-offer').forEach(offer => offer.classList.toggle('is-gift-unlocked', giftUnlocked));
    if (giftUnlocked && lastGiftUnlocked === false) celebrateGiftUnlock();
    lastGiftUnlocked = giftUnlocked;
    const progressAmount = cart.total_price;
    const progressRemaining = Math.max(0, threshold - progressAmount);
    const progress = document.querySelector('[data-dt-routine-progress]');
    if (progress) {
      progress.querySelector('[data-dt-routine-progress-copy]').innerHTML = progressRemaining ? `Unlocking · <strong>${format(progressRemaining)}</strong> to go` : '<strong>Free towel unlocked</strong>';
      progress.querySelector('[data-dt-routine-progress-values]').textContent = `${format(progressAmount)} / ₹2,999`;
      progress.querySelector('[data-dt-routine-progress-fill]').style.width = `${Math.min(100, progressAmount / threshold * 100)}%`;
      progress.querySelector('[data-dt-routine-progress-track]').setAttribute('aria-valuenow', Math.min(2999, Math.floor(progressAmount / 100)));
    }
    document.querySelectorAll('[data-dt-diwali-cart-title]').forEach(node => {
      node.textContent = remaining ? 'Unlock your free terry towel' : 'Free terry towel unlocked';
    });
    document.querySelectorAll('[data-dt-diwali-cart-copy]').forEach(node => {
      node.textContent = remaining ? `Shop for ${format(remaining)} more to reach ₹2,999` : 'Your order qualifies for a complimentary terry towel';
    });
  };
  document.addEventListener('cart:updated', event => event.detail?.total_price != null ? update(event.detail) : refresh());
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, event => event.cartData?.total_price != null ? update(event.cartData) : refresh());
    }
    refresh();
    const deadline = document.querySelector('[data-dt-diwali-deadline]');
    if (deadline) {
      const end = Date.parse(deadline.dataset.end);
      const fields = ['days', 'hours', 'minutes', 'milliseconds'].map(unit => deadline.querySelector(`[data-dt-deadline-${unit}]`));
      let timer;
      let visible = false;
      const tick = () => {
        const remaining = Math.max(0, end - Date.now());
        const values = [Math.floor(remaining / 86400000), Math.floor(remaining / 3600000) % 24, Math.floor(remaining / 60000) % 60, remaining % 1000];
        fields.forEach((field, index) => {
          const value = String(values[index]).padStart(index === 3 ? 3 : 2, '0');
          if (field.textContent !== value) field.textContent = value;
        });
        if (!remaining) {
          deadline.hidden = true;
          document.querySelectorAll('.dt-routine-gift, .dt-routine-progress, .dt-diwali-pdp-offer').forEach(node => { node.hidden = true; });
          window.clearInterval(timer);
        }
      };
      tick();
      const sync = () => {
        window.clearInterval(timer);
        if (visible && !document.hidden && !deadline.hidden) timer = window.setInterval(tick, 100);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); }, { rootMargin: '100px' }).observe(deadline);
      } else {
        visible = true;
        sync();
      }
      document.addEventListener('visibilitychange', sync);
    }
  });
})();
